// TODO: delete this directive when patient-modal-name component will be migrated to react
export default angular
  .module('doxy.common.directives.dValidateSafe', [])
  .directive('dValidateSafe', function () {
    return {
      restrict: 'A',
      scope: false,
      require: 'ngModel',
      link: function (scope, el, attrs, ngModelCtrl) {
        ngModelCtrl.$validators[attrs.ngModel] = (modelVal, viewVal) => {
          const val = modelVal || viewVal;
          const unsafePattern =
            /(<|>|{|}|((https?:)?\/\/|www\.)[^\/\s]+|{{.*}})/i;

          if (val) {
            return !unsafePattern.test(el.val());
          } else {
            return true;
          }
        };
      },
    };
  }).name;
